import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export abstract class SummitDisposing implements OnDestroy {
  protected disposing$ = new Subject();

  ngOnDestroy(): void {
    this.disposing$.next(null);
    this.disposing$.complete();
  }
}
